import {
  createListSearch,
  type ListSearch,
  type ResolvedListSearch,
} from '@/lib/list/list-search';

/**
 * The URL contract for the project list (spec R6.5).
 *
 * The sort keys are the API's own `field:direction` strings rather than a
 * client-side alias, so what is in the URL is what is sent to the server and
 * there is no table in the middle to get out of step with
 * `PROJECT_SORTABLE_FIELDS`.
 */

export const PROJECT_SORTS = ['updatedAt:desc', 'name:asc'] as const;

export type ProjectSort = (typeof PROJECT_SORTS)[number];

/** Most recently touched first — what a reviewer opening Atlas wants to see. */
export const DEFAULT_PROJECT_SORT: ProjectSort = 'updatedAt:desc';

/** Labels for the sort control, in the order they are offered. */
export const PROJECT_SORT_OPTIONS: ReadonlyArray<{
  value: ProjectSort;
  label: string;
}> = [
  { value: 'updatedAt:desc', label: 'Recently updated' },
  { value: 'name:asc', label: 'Name (A–Z)' },
];

/** Cards per page (spec R6.5). Three columns at the widest breakpoint. */
export const PROJECTS_PAGE_SIZE = 24;

export const projectsSearchCodec = createListSearch<ProjectSort>({
  sorts: PROJECT_SORTS,
  defaultSort: DEFAULT_PROJECT_SORT,
  pageSize: PROJECTS_PAGE_SIZE,
});

export type ProjectsSearch = ListSearch<ProjectSort>;
export type ResolvedProjectsSearch = ResolvedListSearch<ProjectSort>;

/** The route's `validateSearch`: total, defaulting, never throwing. */
export const validateProjectsSearch = (
  raw: Record<string, unknown>,
): ProjectsSearch => projectsSearchCodec.parse(raw);
